import { render, staticRenderFns } from "./CustomerPortalLayout.vue?vue&type=template&id=1726b8dc&"
import script from "./CustomerPortalLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports